import React from "react";
import PropTypes from "prop-types";
import { RoleCard } from "components/Missions/Roles";
import Overlay from "components/Overlay";
import { PrimaryLink } from "components/Links";
import { shortenText } from "utils";
import { useLinks } from "hooks";

/**
 * RoleOverlay
 *
 * @param {Object} mission
 * @param {Object} missionRole
 * @param {Boolean} withOverlay
 */
const RoleOverlay = ({ mission, missionRole, withOverlay, ...props }) => {
  const links = useLinks();

  const Link = () => (
    <PrimaryLink to={links.mission_role_details(mission?.uuid, missionRole?.slug)} routerEnabled>
      {shortenText(missionRole?.name, 80)}
    </PrimaryLink>
  );

  if (!withOverlay) {
    return <Link />;
  }

  return (
    <Overlay
      asCardOverlay
      overlay={<RoleCard data={{ ...missionRole, mission }} hideApplyButton />}
      trigger={<Link />}
      {...props}
    />
  );
};

RoleOverlay.propTypes = {
  mission: PropTypes.object.isRequired,
  missionRole: PropTypes.object.isRequired,
  withOverlay: PropTypes.bool,
};

export default RoleOverlay;
